<!-- 头部返回栏目 -->
<template>
  <div>
    <div class="xiame-bank-ascend-gold-header">
      <img
        :src="require(`@/assets/imgs/xiamenBankAscendGold/left1.png`)"
        alt=""
        @click="back"
      />
      <span>厦门国际银行</span>
      <span></span>
    </div>
    <!-- 退出确认弹窗 -->
    <ExitConfirmation ref="exitConfirmationRef" />
  </div>
</template>
<script>
import { toEventHomePage } from './community'
import ExitConfirmation from './ExitConfirmation.vue'
export default {
  components: { ExitConfirmation },
  props: ['isClose',],
  data() {
    return {
      show: false
    }
  },
  methods: {
    back() {
      if (this.isClose) {
        // this.$refs.exitConfirmationRef.show = true
        // toEventHomePage()
        // eslint-disable-next-line no-undef
        XIBLS.closeWindow() // 银行app内关闭当前页面
      } else {
        this.$router.back()
      }
    },
    setShow(val) {
      this.show = val
    },
    toEventHomePage() {
      console.log('去活动首页');
      toEventHomePage()
    }
  },
}
</script>
<style lang="less">
.xiame-bank-ascend-gold-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  width: calc(100% - 20px);
  background: #fff;
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding: 10px;

  img {
    width: 20px;
  }

  span {
    display: inline-block;
    min-width: 10px;
    min-height: 10px;
  }
}
</style>
